export default __webpack_public_path__ + "static/media/itemShadow.e134a86b.svg";